export class ErrorResponse {
  type!: string;
  message!: string;
  response!: string;
}
